const formatDate = (date: Date = new Date()): string => {
  //return `${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()}`;
  return 'Date ???';
}
   
export default formatDate;